import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { loc } from '../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import '../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import { OAuthError } from './Errors.js';

var InlineErrorType = function InlineErrorType() {
  _classCallCheck(this, InlineErrorType);

  this.inline = true;
};

var TerminalErrorType = function TerminalErrorType() {
  _classCallCheck(this, TerminalErrorType);

  this.terminal = true;
};

var TypedOAuthError = /*#__PURE__*/function (_OAuthError) {
  _inherits(TypedOAuthError, _OAuthError);

  var _super = _createSuper(TypedOAuthError);

  function TypedOAuthError(originalError, errorTypeCtor) {
    var _this;

    _classCallCheck(this, TypedOAuthError);

    _this = _super.call(this, originalError.message);
    _this.errorType = void 0;
    _this.orginalError = void 0;
    _this.errorDetails = void 0;
    _this.errorType = new errorTypeCtor();
    _this.orginalError = originalError;
    _this.errorDetails = {
      errorSummary: _this.getErrorSummary(),
      errorCode: originalError.errorCode,
      errorCauses: 'errorCauses' in originalError ? originalError.errorCauses : undefined
    };
    return _this;
  }

  _createClass(TypedOAuthError, [{
    key: "getErrorSummary",
    value: function getErrorSummary() {
      return this.orginalError.errorSummary;
    }
  }, {
    key: "is",
    value: function is(errorTrait) {
      var _Object$getOwnPropert;

      return Boolean((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(this.errorType, errorTrait)) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.value);
    }
  }]);

  return TypedOAuthError;
}(OAuthError);

var RecoverableError = /*#__PURE__*/function (_TypedOAuthError) {
  _inherits(RecoverableError, _TypedOAuthError);

  var _super2 = _createSuper(RecoverableError);

  function RecoverableError() {
    _classCallCheck(this, RecoverableError);

    return _super2.apply(this, arguments);
  }

  return RecoverableError;
}(TypedOAuthError);

var NonRecoverableError = /*#__PURE__*/function (_TypedOAuthError2) {
  _inherits(NonRecoverableError, _TypedOAuthError2);

  var _super3 = _createSuper(NonRecoverableError);

  function NonRecoverableError() {
    _classCallCheck(this, NonRecoverableError);

    return _super3.apply(this, arguments);
  }

  return NonRecoverableError;
}(TypedOAuthError);

var ClockDriftError = /*#__PURE__*/function (_RecoverableError) {
  _inherits(ClockDriftError, _RecoverableError);

  var _super4 = _createSuper(ClockDriftError);

  function ClockDriftError(error) {
    _classCallCheck(this, ClockDriftError);

    return _super4.call(this, error, TerminalErrorType);
  }

  _createClass(ClockDriftError, [{
    key: "getErrorSummary",
    value: function getErrorSummary() {
      return loc('error.unsynced.clock', 'login');
    }
  }]);

  return ClockDriftError;
}(RecoverableError);

var UserNotAssignedError = /*#__PURE__*/function (_RecoverableError2) {
  _inherits(UserNotAssignedError, _RecoverableError2);

  var _super5 = _createSuper(UserNotAssignedError);

  function UserNotAssignedError(error) {
    _classCallCheck(this, UserNotAssignedError);

    return _super5.call(this, error, InlineErrorType);
  }

  return UserNotAssignedError;
}(RecoverableError);

var JITProfileProvisioningError = /*#__PURE__*/function (_RecoverableError3) {
  _inherits(JITProfileProvisioningError, _RecoverableError3);

  var _super6 = _createSuper(JITProfileProvisioningError);

  function JITProfileProvisioningError(error) {
    _classCallCheck(this, JITProfileProvisioningError);

    return _super6.call(this, error, InlineErrorType);
  }

  _createClass(JITProfileProvisioningError, [{
    key: "getErrorSummary",
    value: function getErrorSummary() {
      return loc('error.jit_failure', 'login');
    }
  }]);

  return JITProfileProvisioningError;
}(RecoverableError);

var MfaRequiredError = /*#__PURE__*/function (_NonRecoverableError) {
  _inherits(MfaRequiredError, _NonRecoverableError);

  var _super7 = _createSuper(MfaRequiredError);

  function MfaRequiredError(error) {
    _classCallCheck(this, MfaRequiredError);

    return _super7.call(this, error, InlineErrorType);
  }

  _createClass(MfaRequiredError, [{
    key: "getErrorSummary",
    value: function getErrorSummary() {
      return loc('error.mfa.required', 'login');
    }
  }]);

  return MfaRequiredError;
}(NonRecoverableError);

function getTypedOAuthError(error) {
  switch (error.errorCode) {
    case 'access_denied':
      return new UserNotAssignedError(error);

    case 'jit_failure_missing_fields':
    case 'jit_failure_invalid_login_format':
    case 'jit_failure_values_not_match_pattern':
    case 'jit_failure_values_too_long':
    case 'jit_failure_invalid_locale':
      return new JITProfileProvisioningError(error);

    case 'login_required':
      var mfaRequiredMsg = 'The client specified not to prompt, but the client app requires re-authentication or MFA.';

      if (error.message === mfaRequiredMsg) {
        return new MfaRequiredError(error);
      }

    case 'INTERNAL':
      var clockDriftMsg = 'The JWT was issued in the future';

      if (error.message === clockDriftMsg) {
        return new ClockDriftError(error);
      }

    default:
      return new RecoverableError(error, Object);
  }
}

export { ClockDriftError, JITProfileProvisioningError, MfaRequiredError, NonRecoverableError, RecoverableError, TypedOAuthError, UserNotAssignedError, getTypedOAuthError };